// extracted by mini-css-extract-plugin
export default {"mobileMenu":"styles-module__mobileMenu__src-labstep-web-components-Layout-RightPane-IndexPage-_TnYjo"};